import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { IFlowCore, IFlowSubscriber } from '../../../modules/epflow'
import { config } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'

Locale.getInstance().registerKeySet('fr', 'create-contribution-submitted', {
  title: 'Contributeur soumis!',
  description:
    "On a bien reçu votre demande, vous recevrez un accusé de réception à l'adresse liée à votre compte. Une fois votre contributeur approuvé, vous serez en mesure de la rechercher et pourrez l'ajouter à des évenements, représentations, expositions et festivals.",
  buttonText: "Retourner à l'espace pro",
})

Locale.getInstance().registerKeySet('en', 'create-contribution-submitted', {
  title: 'Contributor submitted!',
  description:
    'Your request has been received, you will get a confirmation email at the address linked to your account. Once your contributor is approved, you will be able to search for it and add it to events, representations, exhibitions, and festivals.',
  buttonText: 'Return to pro space',
})

export interface LvcCreateContributorSubmitted {
  flowGroup: string
  flowStep: string
}

export class LvcCreateContributorSubmitted
  extends MinzeElement
  implements MinzeElement, IFlowSubscriber
{
  private core: IFlowCore | undefined
  private iconSize: string = '400px'

  attrs: Attrs = [
    ['flow-step', ''],
    ['flow-group', ''],
  ]

  reactive: Reactive = []

  onClickPartnerPage() {
    const lang = MainModule.getInstance().getLang() as 'fr' | 'en'
    window.location.href = config.proSpaceUrl[lang]
  }

  html(): string {
    const mobile = window.innerWidth < 960

    const titleSize = mobile ? 'titleMobileSmall' : 'titleDesktopSmall'
    const messageSize = mobile ? 'medium' : 'large'
    this.iconSize = mobile ? '300px' : '400px'

    return `
      <div class="container">
        <lvc-box class="icon">
          <lvc-charlie-peacesign-icon width="${this.iconSize}" height="${this.iconSize}"></lvc-charlie-peacesign-icon>
        </lvc-box>
        <lvc-box class="title">
          <lvc-text font-preset=${titleSize} class="lvc-modal-title">${Locale.getKey('create-contribution-submitted.title')}</lvc-text>
        </lvc-box>
        <lvc-box class="message">
          <lvc-text font-preset=${messageSize} class="lvc-modal-title">${Locale.getKey('create-contribution-submitted.description')}</lvc-text>
        </lvc-box>
        <lvc-box class="buttonContainer">
          <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia(' (max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button"
              height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px" name="partnerPageButton"> ${Locale.getKey('create-contribution-submitted.buttonText')} </lvc-button>
        </lvc-box>
      </div>
    `
  }

  css() {
    return `
    :host {
     
    }
    
    .container {
        text-align: center;
      }
    
      .message {
        margin-top: 10px;
      }
    
      .buttonContainer {
        margin-top: 32px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .icon{
        display: flex;
        justify-content: center;
        align-items: center;

      }

  `
  }

  eventListeners: EventListeners = [
    ['[name=partnerPageButton]', 'click', this.onClickPartnerPage.bind(this)],
  ]
}
